import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { PlanningDetailsPage } from './planning-details';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material';
import { ComponentsModule } from '../../components/components.module'

@NgModule({
  declarations: [
    PlanningDetailsPage,
  ],
  imports: [
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    ComponentsModule,
    IonicPageModule.forChild(PlanningDetailsPage)
  ],
})
export class PlanningDetailsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/planning-details/planning-details.module.ts